import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CancelIcon from "../Icons/CancelIcon";
import DelayIcon from "../Icons/DelayIcon";
import FailIcon from "../Icons/FailIcon";
import SuccessIcon from "../Icons/SuccessIcon";
class MessageComponentProps {
}
function constructIcons(icon) {
    let iconStyle;
    switch (icon) {
        case 'red':
            iconStyle = _jsx(FailIcon, {});
            break;
        case 'green':
            iconStyle = _jsx(SuccessIcon, {});
            break;
        case 'yellow':
            iconStyle = _jsx(DelayIcon, {});
            break;
        case 'gray':
            iconStyle = CancelIcon;
            break;
    }
    return iconStyle;
}
const MessageComponent = ({ children }) => {
    return _jsx("div", { className: "w-full flex flex-col h-full justify-between pt-6 min-h-full", children: children });
};
const Content = ({ children, icon, center }) => {
    return (center ?
        _jsx("div", { className: 'flex flex-col self-center grow w-full', children: _jsx("div", { className: 'flex self-center grow w-full', children: _jsxs("div", { className: 'flex flex-col space-y-8 self-center w-full', children: [icon ?
                            _jsx("div", { className: 'flex place-content-center', children: constructIcons(icon) })
                            : null, children] }) }) })
        :
            _jsxs("div", { className: 'space-y-3', children: [icon ?
                        _jsx("div", { className: 'flex place-content-center', children: constructIcons(icon) })
                        : null, children] }));
};
const Header = ({ children, className }) => {
    return _jsx("div", { className: `md:text-3xl text-lg font-bold text-primary-text leading-6 text-center ${className}`, children: children });
};
const Description = ({ children }) => {
    return _jsx("div", { className: "text-base font-medium space-y-6 text-secondary-text text-center mb-6", children: children });
};
const Buttons = ({ children }) => {
    return _jsx("div", { className: "space-y-3", children: children });
};
MessageComponent.Content = Content;
MessageComponent.Header = Header;
MessageComponent.Description = Description;
MessageComponent.Buttons = Buttons;
export default MessageComponent;
